<!-- Редактирует стили шаблона документа для глобального режима и таблиц -->
<template>
  <div class="style-editor">
    <!-- Заголовок для глобального режима -->
    <div
      v-if="isGlobalMode"
      class="style-editor-header"
      @click="toggleSection"
    >
      <div class="header-left">
        <base-toggle-arrow-button :section-visible="sectionVisible" />
        <span class="style-title">Стили шаблона</span>
      </div>
    </div>

    <!-- Заголовок для режима блока -->
    <div v-else class="style-editor-header">
      <span class="style-title">Стили блока</span>
      <div class="style-header-actions">
        <base-checkbox v-model="enableCustomStyles">
          Настроить стили
        </base-checkbox>
      </div>
    </div>

    <!-- Тело редактора для глобального режима -->
    <div
      v-if="isGlobalMode && sectionVisible"
      class="style-editor-body"
    >
      <div class="style-section">
        <!-- Размеры шрифтов -->
        <div class="style-row">
          <div class="style-label">
            <base-label>Размер шрифта (pt)</base-label>
          </div>
          <div class="style-control">
            <base-input
              type="number"
              v-model.number="localStyle.size"
              min="6"
              max="72"
              step="0.5"
              :placeholder="getPlaceholder('size')"
              @update:modelValue="handleStyleChange('size', $event)"
            />
          </div>
        </div>

        <div class="style-row">
          <div class="style-label">
            <base-label>Размер заголовка (pt)</base-label>
          </div>
          <div class="style-control">
            <base-input
              type="number"
              v-model.number="localStyle.label_size"
              min="6"
              max="72"
              step="0.5"
              :placeholder="getPlaceholder('label_size')"
              @update:modelValue="
                handleStyleChange('label_size', $event)
              "
            />
          </div>
        </div>

        <div class="style-row">
          <div class="style-label">
            <base-label>Размер значения (pt)</base-label>
          </div>
          <div class="style-control">
            <base-input
              type="number"
              v-model.number="localStyle.value_size"
              min="6"
              max="72"
              step="0.5"
              :placeholder="getPlaceholder('value_size')"
              @update:modelValue="
                handleStyleChange('value_size', $event)
              "
            />
          </div>
        </div>

        <!-- Выравнивание -->
        <div class="style-row">
          <div class="style-label">
            <base-label>Выравнивание текста</base-label>
          </div>
          <div class="style-control">
            <base-select
              v-model="localStyle.align"
              :options="alignOptions"
              :placeholder="getPlaceholder('align', true)"
              @update:modelValue="handleStyleChange('align', $event)"
            />
          </div>
        </div>

        <!-- Отступы -->
        <div class="style-row">
          <div class="style-label">
            <base-label>Верхний отступ (mm)</base-label>
          </div>
          <div class="style-control">
            <base-input
              type="number"
              v-model.number="localStyle.top_padding"
              min="0"
              max="50"
              step="0.5"
              :placeholder="getPlaceholder('top_padding')"
              @update:modelValue="
                handleStyleChange('top_padding', $event)
              "
            />
          </div>
        </div>

        <div class="style-row">
          <div class="style-label">
            <base-label>Нижний отступ (mm)</base-label>
          </div>
          <div class="style-control">
            <base-input
              type="number"
              v-model.number="localStyle.bottom_padding"
              min="0"
              max="50"
              step="0.5"
              :placeholder="getPlaceholder('bottom_padding')"
              @update:modelValue="
                handleStyleChange('bottom_padding', $event)
              "
            />
          </div>
        </div>

        <div class="style-row">
          <div class="style-label">
            <base-label>Отступ заголовка (mm)</base-label>
          </div>
          <div class="style-control">
            <base-input
              type="number"
              v-model.number="localStyle.label_spacing"
              min="0"
              max="20"
              step="0.5"
              :placeholder="getPlaceholder('label_spacing')"
              @update:modelValue="
                handleStyleChange('label_spacing', $event)
              "
            />
          </div>
        </div>

        <!-- Цвет фона заголовков таблицы -->
        <div class="style-row">
          <div class="style-label">
            <base-label>Цвет фона заголовков таблицы</base-label>
          </div>
          <div class="style-control">
            <div class="color-picker-wrapper">
              <input
                type="color"
                v-model="colorValue"
                class="color-picker"
                @input="updateColor"
              />
              <base-input
                v-model="localStyle.table_headers_background_color"
                :placeholder="
                  getPlaceholder('table_headers_background_color')
                "
                class="color-input"
                @update:modelValue="
                  handleStyleChange(
                    'table_headers_background_color',
                    $event
                  )
                "
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="!isGlobalMode && enableCustomStyles"
      class="style-editor-body"
    >
      <div class="style-section">
        <!-- Размеры шрифтов -->
        <div class="style-row">
          <div class="style-label">
            <base-label>Размер шрифта (pt)</base-label>
          </div>
          <div class="style-control">
            <base-input
              type="number"
              v-model.number="localStyle.size"
              min="6"
              max="72"
              step="0.5"
              :placeholder="getPlaceholder('size')"
              @update:modelValue="handleStyleChange('size', $event)"
            />
          </div>
        </div>

        <div class="style-row">
          <div class="style-label">
            <base-label>Размер заголовка (pt)</base-label>
          </div>
          <div class="style-control">
            <base-input
              type="number"
              v-model.number="localStyle.label_size"
              min="6"
              max="72"
              step="0.5"
              :placeholder="getPlaceholder('label_size')"
              @update:modelValue="
                handleStyleChange('label_size', $event)
              "
            />
          </div>
        </div>

        <div class="style-row">
          <div class="style-label">
            <base-label>Размер значения (pt)</base-label>
          </div>
          <div class="style-control">
            <base-input
              type="number"
              v-model.number="localStyle.value_size"
              min="6"
              max="72"
              step="0.5"
              :placeholder="getPlaceholder('value_size')"
              @update:modelValue="
                handleStyleChange('value_size', $event)
              "
            />
          </div>
        </div>

        <!-- Выравнивание -->
        <div class="style-row">
          <div class="style-label">
            <base-label>Выравнивание текста</base-label>
          </div>
          <div class="style-control">
            <base-select
              v-model="localStyle.align"
              :options="alignOptions"
              :placeholder="getPlaceholder('align', true)"
              @update:modelValue="handleStyleChange('align', $event)"
            />
          </div>
        </div>

        <!-- Отступы -->
        <div class="style-row">
          <div class="style-label">
            <base-label>Верхний отступ (mm)</base-label>
          </div>
          <div class="style-control">
            <base-input
              type="number"
              v-model.number="localStyle.top_padding"
              min="0"
              max="50"
              step="0.5"
              :placeholder="getPlaceholder('top_padding')"
              @update:modelValue="
                handleStyleChange('top_padding', $event)
              "
            />
          </div>
        </div>

        <div class="style-row">
          <div class="style-label">
            <base-label>Нижний отступ (mm)</base-label>
          </div>
          <div class="style-control">
            <base-input
              type="number"
              v-model.number="localStyle.bottom_padding"
              min="0"
              max="50"
              step="0.5"
              :placeholder="getPlaceholder('bottom_padding')"
              @update:modelValue="
                handleStyleChange('bottom_padding', $event)
              "
            />
          </div>
        </div>

        <div class="style-row">
          <div class="style-label">
            <base-label>Отступ заголовка (mm)</base-label>
          </div>
          <div class="style-control">
            <base-input
              type="number"
              v-model.number="localStyle.label_spacing"
              min="0"
              max="20"
              step="0.5"
              :placeholder="getPlaceholder('label_spacing')"
              @update:modelValue="
                handleStyleChange('label_spacing', $event)
              "
            />
          </div>
        </div>

        <!-- Цвет фона заголовков таблицы -->
        <div
          v-if="tableBlockTypes.includes(blockType)"
          class="style-row"
        >
          <div class="style-label">
            <base-label>Цвет фона заголовков таблицы</base-label>
          </div>
          <div class="style-control">
            <div class="color-picker-wrapper">
              <input
                type="color"
                v-model="colorValue"
                class="color-picker"
                @input="updateColor"
              />
              <base-input
                v-model="localStyle.table_headers_background_color"
                :placeholder="
                  getPlaceholder('table_headers_background_color')
                "
                class="color-input"
                @update:modelValue="
                  handleStyleChange(
                    'table_headers_background_color',
                    $event
                  )
                "
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Кнопки управления для глобального режима -->
    <div v-if="isGlobalMode && sectionVisible" class="global-actions">
      <base-primary-button
        @click="handleSave"
        :loading="isSaving"
        :disabled="!hasChanges"
        class="btn-save"
      >
        Сохранить стили
      </base-primary-button>
      <base-button @click="handleReset" class="btn-reset">
        Сбросить стили
      </base-button>
    </div>

    <!-- Свёрнутое состояние для глобального режима -->
    <div
      v-if="isGlobalMode && !sectionVisible"
      class="style-collapsed"
    >
      <p v-if="hasStyles">Глобальные стили настроены</p>
      <p v-else>Используются стили по умолчанию</p>
    </div>

    <!-- Пустое состояние для режима блока -->
    <div
      v-if="!isGlobalMode && !enableCustomStyles"
      class="style-empty"
    >
      <div class="empty-icon">🎨</div>
      <p>Стили наследуются из шаблона</p>
    </div>

    <BaseDialog
      :visible="showResetDialog"
      title="Сбросить стили?"
      message="Все глобальные стили шаблона будут удалены"
      :actions="[
        { key: 'confirm', label: 'Сбросить', type: 'danger' },
        { key: 'close', label: 'Отмена', type: 'secondary' },
      ]"
      @action="handleResetDialogAction"
    />
  </div>
</template>

<script>
const DEFAULT_STYLES = {
  label_spacing: 2,
  size: 10,
  align: "left",
  label_size: 10,
  value_size: 8,
  top_padding: 2,
  bottom_padding: 4,
  table_headers_background_color: "c3d9ff",
};

export default {
  name: "TemplateStyleEditor",
  props: {
    modelValue: {
      type: Object,
      default: () => ({}),
    },
    blockType: {
      type: String,
      default: "",
    },
    templateStyles: {
      type: Object,
      default: () => ({}),
    },
    isGlobalMode: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue", "save", "cancel", "reset"],
  data() {
    return {
      sectionVisible: false,
      enableCustomStyles: false,
      localStyle: {},
      originalStyles: {},
      alignOptions: [
        { value: "left", label: "Слева" },
        { value: "center", label: "По центру" },
        { value: "right", label: "Справа" },
      ],
      tableBlockTypes: [
        "table",
        "items_table",
        "sectioned_items_table",
      ],
      updating: false,
      isSaving: false,
      showResetDialog: false,
    };
  },
  computed: {
    colorValue: {
      get() {
        const color =
          this.localStyle.table_headers_background_color ||
          this.templateStyles.table_headers_background_color ||
          DEFAULT_STYLES.table_headers_background_color;
        return color.startsWith("#") ? color : `#${color}`;
      },
      set(value) {
        this.handleStyleChange(
          "table_headers_background_color",
          value.substring(1)
        );
      },
    },

    hasChanges() {
      if (!this.isGlobalMode) return false;
      return (
        JSON.stringify(this.getCurrentStyles()) !==
        JSON.stringify(this.originalStyles)
      );
    },

    hasStyles() {
      return (
        this.localStyle && Object.keys(this.localStyle).length > 0
      );
    },
  },
  watch: {
    modelValue: {
      handler(newVal) {
        if (this.updating) {
          this.updating = false;
          return;
        }
        this.initLocalStyle(newVal);
      },
      deep: true,
      immediate: true,
    },
    enableCustomStyles(newVal) {
      if (newVal) {
        this.emitUpdate();
      } else {
        this.localStyle = {};
        this.$emit("update:modelValue", null);
      }
    },
  },
  methods: {
    toggleSection() {
      if (this.isGlobalMode) {
        this.sectionVisible = !this.sectionVisible;
      }
    },

    initLocalStyle(style) {
      if (style && Object.keys(style).length > 0) {
        this.enableCustomStyles = true;
        this.localStyle = { ...style };
        if (this.isGlobalMode) {
          this.originalStyles = JSON.parse(JSON.stringify(style));
          this.sectionVisible = true;
        }
      } else {
        this.enableCustomStyles = false;
        this.localStyle = {};
        if (this.isGlobalMode) {
          this.originalStyles = {};
          this.sectionVisible = false;
        }
      }
    },

    getPlaceholder(key, isLabel = false) {
      const inheritedVal = this.templateStyles[key];
      const defaultVal = DEFAULT_STYLES[key];

      let valToShow =
        inheritedVal !== undefined ? inheritedVal : defaultVal;

      if (isLabel && key === "align") {
        const option = this.alignOptions.find(
          (o) => o.value === valToShow
        );
        return option ? option.label : valToShow;
      }

      return String(valToShow);
    },

    formatColor() {
      const color = this.localStyle.table_headers_background_color;
      if (color && color.startsWith("#")) {
        this.localStyle.table_headers_background_color =
          color.substring(1);
      }
    },

    updateColor(event) {
      const hexColor = event.target.value;
      this.handleStyleChange(
        "table_headers_background_color",
        hexColor.substring(1)
      );
    },

    handleStyleChange(key, value) {
      if (value === "" || value === null || value === undefined) {
        delete this.localStyle[key];
      } else {
        this.localStyle[key] = value;
      }

      if (key === "table_headers_background_color") {
        this.formatColor();
      }

      if (!this.isGlobalMode) {
        this.emitUpdate();
      }
    },

    getCurrentStyles() {
      const customStyles = {};
      const allKeys = Object.keys(DEFAULT_STYLES);

      allKeys.forEach((key) => {
        if (
          key === "table_headers_background_color" &&
          !this.isGlobalMode &&
          !this.tableBlockTypes.includes(this.blockType)
        ) {
          return;
        }

        const val = this.localStyle[key];
        if (val !== undefined && val !== null && val !== "") {
          customStyles[key] = val;
        }
      });

      return Object.keys(customStyles).length > 0
        ? customStyles
        : null;
    },

    emitUpdate() {
      if (!this.isGlobalMode && !this.enableCustomStyles) {
        this.$emit("update:modelValue", null);
        return;
      }

      this.updating = true;

      const result = this.getCurrentStyles();

      this.$nextTick(() => {
        this.$emit("update:modelValue", result);
      });
    },

    handleSave() {
      if (!this.isGlobalMode) return;

      this.isSaving = true;
      const styles = this.getCurrentStyles();
      this.$emit("save", styles);
    },

    handleReset() {
      if (!this.isGlobalMode) return;

      this.showResetDialog = true;
    },

    handleResetDialogAction(action) {
      this.showResetDialog = false;

      if (action !== "confirm") {
        return;
      }

      this.localStyle = {};
      this.isSaving = true;
      this.$emit("reset");
    },

    resetSaving() {
      this.isSaving = false;
    },

    updateOriginalStyles(styles) {
      this.originalStyles = JSON.parse(JSON.stringify(styles || {}));
    },
  },
};
</script>

<style scoped>
.style-editor {
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  overflow: hidden;
  margin-top: 16px;
}

.style-editor-header {
  background: #f0f0f0;
  padding: 12px 16px;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.style-editor-header[onclick] {
  cursor: pointer;
  user-select: none;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.style-title {
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.style-header-actions {
  display: flex;
  align-items: center;
}

.style-editor-body {
  padding: 16px;
}

.style-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.style-row {
  display: grid;
  grid-template-columns: 200px 1fr;
  gap: 16px;
  align-items: center;
}

.style-label {
  font-size: 13px;
  font-weight: 500;
  color: #374151;
}

.style-control {
  width: 100%;
}

.color-picker-wrapper {
  display: flex;
  gap: 8px;
  align-items: center;
}

.color-picker {
  width: 40px;
  height: 36px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  cursor: pointer;
  padding: 2px;
}

.color-input {
  flex: 1;
  font-family: "Menlo", "Monaco", "Courier New", monospace;
  font-size: 12px;
}

.style-collapsed {
  padding: 16px;
  text-align: center;
  color: #6b7280;
  font-size: 13px;
}

.style-collapsed p {
  margin: 0;
}

.style-empty {
  padding: 32px 16px;
  text-align: center;
  color: #9ca3af;
}

.empty-icon {
  font-size: 32px;
  margin-bottom: 8px;
  opacity: 0.6;
}

.style-empty p {
  font-size: 13px;
  margin: 0;
}

.global-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #f9fafb;
}

.btn-reset {
  color: var(--color-danger) !important;
  border-color: var(--color-danger) !important;
}

.btn-reset:hover {
  background-color: var(--color-danger) !important;
  color: #fff !important;
}

.btn-save {
  padding: 8px 16px;
  font-size: 13px;
}

.btn-save:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
